import { useCallback, type FC } from 'react';

import { useGetPostCreationOptions } from '@/features/api/hooks/grapevine-post/useGetPostCreationOptions';
import { PostCreationContext } from '@/features/post-editor/types/postCreationOptions';
import { useVerification } from '@/features/verification/providers/useVerification';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { AppRoute } from '@/navigation/types/navigation';
import { FloatingActionButton } from '@/shared/components/FloatingActionButton';

type Props = {
  bottom?: number;
};

export const MeineRegionCreatePostFab: FC<Props> = ({ bottom }) => {
  const navigation = useAppNavigation();
  const { ensureVerified } = useVerification();
  const { data: options } = useGetPostCreationOptions(
    PostCreationContext.MEINE_REGION
  );

  const onPress = useCallback(() => {
    if (!ensureVerified()) {
      return;
    }
    navigation.navigate(AppRoute.PostCreationRegion);
  }, [navigation, ensureVerified]);

  if (!options?.senders.length) {
    return <></>;
  }

  return (
    <FloatingActionButton
      testID="meine-region-create-post-fab"
      onPress={onPress}
      bottom={bottom}
    />
  );
};
